import { styled, WithTheme, Typography } from '@material-ui/core'
import { File, CircleXFilled } from 'shared/icons'

const MAX_WIDTH = 400
const FILE_ICON_SIZE = 35
const REMOVE_ICON_SIZE = 21

interface RemoveIconProps extends WithTheme {
  disabled?: boolean
}

export const Container = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  maxWidth: MAX_WIDTH,
  overflow: 'hidden',
  '& > div': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
})

export const Icon = styled(File)(({ theme }) => ({
  marginRight: theme.spacing(1.7),
  color: theme.palette.primary.main,
  width: FILE_ICON_SIZE,
  height: FILE_ICON_SIZE,
  flexShrink: 0,
}))

export const Link = styled('a')(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: 'underline',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: 'inline-block',
}))

export const Paragraph = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: 'underline',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: 'inline-block',
  cursor: 'pointer',
}))

export const RemoveIcon = styled(CircleXFilled)(
  ({ theme, disabled }: RemoveIconProps) => ({
    marginLeft: theme.spacing(1.4),
    color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    width: REMOVE_ICON_SIZE,
    height: REMOVE_ICON_SIZE,
    cursor: 'pointer',
    flexShrink: 0,
  })
)
